import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { deepEqual } from 'fast-equals';

import OrderHistoryFindOrders from 'components/account/OrderHistoryOverview/OrderHistoryFindOrders';
import OrderHistoryTable from 'components/account/OrderHistoryOverview/OrderHistoryTable';
import Pagination from 'components/account/Pagination';
import { VALID_ORDER } from 'common/regex';
import css from 'styles/components/account/orderHistoryOverview.scss';

const pageSizeValues = [10, 25, 50];

class OrderHistoryOverview extends Component {
  state = {
    searchByOrderIdError: false,
    returnablesAvailable: false
  };

  componentDidMount() {
    this.checkIfReturnablesAreAvailable();
  }

  componentDidUpdate(prevProps) {
    const { orders: prevOrders } = prevProps;
    const { orders } = this.props;
    // If orders are different, check returnables
    if (!deepEqual(prevOrders, orders)) {
      this.checkIfReturnablesAreAvailable(this.props);
    }
  }

  onReturnItems = () => {
    this.context.router.forceBrowserPush('/returns');
  }

  checkIfReturnablesAreAvailable = (props = this.props) => {
    const { orders = [], isLoading } = props;
    this.setState({ returnablesAvailable: !isLoading && orders.some(order => order.returnable) });
  };

  handleSearchByOrderIdSubmit = event => {
    event.preventDefault();
    const { searchByOrderId: { value } } = event.target;
    if (VALID_ORDER.test(value)) {
      this.setState({ searchByOrderIdError: false });
      this.context.router.pushPreserveAppRoot(`/orders/${value}`);
    } else {
      this.setState({ searchByOrderIdError: true });
    }
  };

  handleUpdatePageSize = event => {
    const { location: { pathname, search }, onFetchOrders } = this.props;
    const { value } = event.target;
    const params = queryString.parse(search);
    const queryParams = { ...params, pageSize: value, page: undefined };
    this.context.router.pushPreserveAppRoot(`${pathname}?${queryString.stringify(queryParams)}`);
    onFetchOrders(queryParams);
  };

  makeSearchByOrderNumberErrorMsg() {
    return <p className={css.errorMsg}><strong>Oh No!</strong> Please enter a valid order number.</p>;
  }

  render() {
    const { location, orders, totalPages, isLoading } = this.props;
    const { searchByOrderIdError, returnablesAvailable } = this.state;

    return (
      <div className={css.orderHistoryOverview}>
        { searchByOrderIdError && this.makeSearchByOrderNumberErrorMsg() }
        <OrderHistoryFindOrders
          location={location}
          returnablesAvailable={returnablesAvailable}
          onReturnItems={this.onReturnItems}
          onSearchByOrderIdSubmit={this.handleSearchByOrderIdSubmit}/>
        <OrderHistoryTable
          orders={orders}
          isLoading={isLoading}/>
        <Pagination
          pageSizeValues={pageSizeValues}
          isOverview={true}
          location={location}
          totalPages={totalPages}
          onUpdatePageSize={this.handleUpdatePageSize}/>
      </div>
    );
  }
}

OrderHistoryOverview.contextTypes = {
  router: PropTypes.object.isRequired,
  testId: PropTypes.func
};

OrderHistoryOverview.propTypes = {
  location: PropTypes.object,
  orders: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onFetchOrders: PropTypes.func.isRequired
};

export default OrderHistoryOverview;
